import { render, staticRenderFns } from "./ExcelExporter.vue?vue&type=template&id=70c73fde&scoped=true"
import script from "./ExcelExporter.vue?vue&type=script&lang=js"
export * from "./ExcelExporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c73fde",
  null
  
)

export default component.exports